import React, { useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as chanceApi from '../../../lib/api/chance';
import * as projectApi from '../../../lib/api/project';

import { Box, Grid, Stepper, Step, StepLabel, Button } from '@mui/material';
import ProjectOrderContainer from './ProjectOrderContainer';
import { setProject } from '../../../modules/projectModule/project';
import AskDialog from '../../../components/common/dialog/AskDialog';
import ChanceDelModal from '../../../components/chancemng/info/ChanceDelModal';
// import ProjectStepInfoContainer from '../info/ProjectStepInfoContainer';
// import ProjectGuideContainer from '../info/ProjectGuideContainer';

//수주,착수보고/분석설계/구축(이행)/완료(검수)
const steps = [
  { value: 0, label: '수주품의', color: 'secondary' },
  { value: 1, label: '발주', color: 'success' },
  { value: 2, label: '세금계산서', color: 'error' },
  { value: 3, label: '채권', color: 'info' },
  // { value: 4, label: '완료(검수)', color: 'secondary' },
];

const ProjectStepperContainer = ({
  pageUrl,
  activeStep,
  activeTap,
  handleTabChange,
  handleGoBack,
}) => {
  const stepperRef = useRef();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
  }));

  const [message, setMessage] = useState(
    '기본사항 등록이 완료되지 못했습니다.',
  );
  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
  };

  const handleBack = () => {
    let dataToSubmit = {
      prjUuid: project.prjUuid,
    };
    if (Number(project.cmpGrade) === 1) {
      dataToSubmit.cmpGrade = 0;
      dataToSubmit.cmpStatus = '수주품의';
      updateOrderStatus(dataToSubmit);
    }

    if (Number(project.cmpGrade) === 2) {
      dataToSubmit.cmpGrade = 1;
      dataToSubmit.cmpStatus = '발주';
      updateOrderStatus(dataToSubmit);
    }

    if (Number(project.cmpGrade) === 3) {
      dataToSubmit.cmpGrade = 2;
      dataToSubmit.cmpStatus = '세금계산서';
      updateOrderStatus(dataToSubmit);
    }
  };

  const handleNext = () => {
    //현재 단계에서 모든 상세가 입력되었는지 확인
    let dataToSubmit = {
      prjUuid: project.prjUuid,
    };

    if (Number(project.cmpGrade) === 0) {
      dataToSubmit.cmpGrade = 1;
      dataToSubmit.cmpStatus = '발주';
      //수주품의서의 작성 상태 확인 필요.
      updateOrderStatus(dataToSubmit);
    }

    if (Number(project.cmpGrade) === 1) {
      dataToSubmit.cmpGrade = 2;
      dataToSubmit.cmpStatus = '세금계산서';
      updateProjectStatus(dataToSubmit);
    }

    if (Number(project.cmpGrade) === 2) {
      dataToSubmit.cmpGrade = 3;
      dataToSubmit.cmpStatus = '채권';
      updateProjectStatus(dataToSubmit);
    }

    // if (Number(project.cmpGrade) === 3) {
    //   dataToSubmit.cmpGrade = 4;
    //   dataToSubmit.cmpStatus = '완료(검수)';
    //   updateProjectStatus(dataToSubmit);
    // }
  };

  //수주품의서 상태 확인
  const updateOrderStatus = async (dataToSubmit) => {
    try {
      const res = await chanceApi.getChanceOrderCount(project.prjUuid);
      //console.log(res.data);

      if (!res.data.count || res.data.count === 0) {
        setMessage('작성된 수주품의서가 없습니다. 수주품의서를 작성하세요');
        setVisible(true);
        return;
      }

      if (
        !res.data.list ||
        !res.data.list.ordYn ||
        res.data.list.ordYn !== 'Y'
      ) {
        setMessage('수주품의서가 결제되지 않았습니다. 결제 여부를 확인하세요.');
        setVisible(true);
        return;
      }

      updateProjectStatus(dataToSubmit);
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const updateProjectStatus = async (dataToSubmit) => {
    try {
      // console.log(dataToSubmit,'dataToSubmit');
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        dispatch(setProject(res.data.info));
        navigate(
          `/projectmng/${dataToSubmit.prjUuid}/${dataToSubmit.cmpGrade}/1`,
        );
        enqueueSnackbar(`[${dataToSubmit.cmpStatus}] 상태 변경 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [copyVisible, setCopyVisible] = useState(false);
  const onCopyCancle = () => {
    setCopyVisible(false);
  };
  const onCopyConfirm = () => {
    //프로젝트 복사
    onCopyProject();
    setCopyVisible(false);
  };

  const onCopyProject = async () => {
    try {
      const res = await projectApi.copyProject(project.prjUuid);
      if (res.data) {
        navigate(`/${pageUrl}`);
        enqueueSnackbar(`프로젝트 복사 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const onRemoveCancle = () => {
    setRemoveVisible(false);
  };
  const onRemoveConfirm = () => {
    //프로젝트 삭제
    onRemoveProject();
    setRemoveVisible(false);
  };

  const onRemoveProject = async () => {
    try {
      const res = await chanceApi.removeChance(project.prjUuid);
      if (res.data) {
        handleGoBack();
        enqueueSnackbar(`프로젝트 삭제 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* <Grid container spacing={2} sx={{ height: '400px', my: 1 }}>
        <Grid item xs={5}>
          <ProjectStepInfoContainer />
        </Grid>
        <Grid item xs={7}>
          <ProjectGuideContainer />
        </Grid>
      </Grid> */}
      <div ref={stepperRef}></div>

      <Stepper
        sx={{
          pt: 2,
          pb: 1,
          backgroundColor: '#eee',
        }}
        activeStep={activeStep}
        alternativeLabel
      >
        {steps.map((step) => {
          const stepProps = {};
          const labelProps = {};

          if (activeStep === steps.length - 1) {
            stepProps.completed = true;
          }
          return (
            <Step key={step.label} {...stepProps}>
              <StepLabel
                {...labelProps}
                // StepIconProps={{
                //   style: {
                //     color: '#424242'
                //   }
                // }}
              >
                {step.label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          py: 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button
              variant="contained"
              color="error"
              onClick={() => setRemoveVisible(true)}
            >
              삭제
            </Button>
          </Box>
          <Box sx={{ mx: 2 }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setCopyVisible(true)}
            >
              복사
            </Button>
          </Box>
          {Number(activeStep) !== 0 && (
            <Box sx={{ mx: 2 }}>
              <Button
                variant="contained"
                color={steps[Number(activeStep - 1)].color}
                onClick={handleBack}
              >
                {steps[activeStep - 1].label}
              </Button>
            </Box>
          )}
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />

        {Number(activeStep) < steps.length - 1 && (
          <Button
            variant="contained"
            color={steps[Number(activeStep + 1)].color}
            onClick={handleNext}
          >
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <ProjectOrderContainer
          activeTap={activeTap}
          handleTabChange={handleTabChange}
          stepperRef={stepperRef}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          py: 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box>
          <Button
            variant="contained"
            color="error"
            onClick={() => setRemoveVisible(true)}
          >
            삭제
          </Button>
        </Box>

        <Box sx={{ flex: '1 1 auto' }} />

        {Number(activeStep) < steps.length - 1 && (
          <Button
            variant="contained"
            color={steps[Number(activeStep + 1)].color}
            onClick={handleNext}
          >
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>
      <AskDialog
        visible={visible}
        title="다음단계 이동"
        description={message}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      <AskDialog
        visible={copyVisible}
        title="프로젝트 복사"
        description="해당 프로젝트를 복사하시겠습니까?"
        onConfirm={onCopyConfirm}
        onCancle={onCopyCancle}
      />
      <AskDialog
        visible={removeVisible}
        title="프로젝트 삭제"
        description="해당 프로젝트를 삭제하시겠습니까?(복구 불가)"
        onConfirm={onRemoveConfirm}
        onCancle={onRemoveCancle}
      />
    </Box>
  );
};

export default ProjectStepperContainer;
